import React, { useState, useEffect } from "react";
import { putGasto as modifGasto } from "../helpers/rutaGastos";
import { getCuentaGastos } from "../helpers/rutaCuentaGastos";
import { Modal, Button, Alert } from "react-bootstrap";
import "animate.css";

const ModalFormGasto = ({ gasto, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [cuentas, setCuentas] = useState({ data: [], loading: true });

  const [formValues, setFormValues] = useState({
    codgas: "",
    gasto: "",
    cuenta: "",
    activo: true,
  });

  useEffect(() => {
    const cargarCuentas = async () => {
      try {
        const resp = await getCuentaGastos();

        const lista = Array.isArray(resp)
          ? resp
          : resp?.cuentagastos || [];

        setCuentas({
          data: lista.filter((x) => x.activo !== false),
          loading: false,
        });
      } catch (error) {
        console.error(
          "❌ Error al cargar cuentas de gasto:",
          error?.response?.data || error
        );
        setCuentas({ data: [], loading: false });
        setErrorMsg("No se pudieron cargar las cuentas de gasto");
      }
    };

    cargarCuentas();
  }, []);

  useEffect(() => {
    if (gasto && gasto._id) {
      const cuentaId =
        typeof gasto.cuenta === "string"
          ? gasto.cuenta
          : gasto.cuenta?._id || "";

      setFormValues({
        codgas: gasto.codgas || "",
        gasto: gasto.gasto || "",
        cuenta: cuentaId,
        activo: gasto.activo ?? true,
      });

      setErrorMsg("");
    }
  }, [gasto]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!gasto?._id) return;

    const payload = {
      gasto: String(formValues.gasto || "").trim(),
      cuenta: formValues.cuenta,
      activo: !!formValues.activo,
    };

    if (!payload.cuenta) {
      setErrorMsg("Debe seleccionar una cuenta");
      return;
    }

    if (!payload.gasto) {
      setErrorMsg("Debe ingresar un gasto");
      return;
    }

    try {
      const resp = await modifGasto(gasto._id, payload);
      console.log("✅ Gasto actualizado:", resp);

      if (resp?.ok === false) {
        setErrorMsg("No se pudo guardar el gasto");
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1200);
    } catch (error) {
      console.error(
        "❌ Error al actualizar gasto:",
        error?.response?.data || error
      );
      setErrorMsg(
        error?.response?.data?.message ||
          error?.response?.data?.err?.message ||
          "Error al actualizar el gasto"
      );
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Gasto</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {errorMsg ? <Alert variant="danger">{errorMsg}</Alert> : null}

            <div className="form-group mt-2">
              <label>Cuenta</label>
              <select
                className="form-control"
                name="cuenta"
                required
                value={formValues.cuenta}
                onChange={handleChange}
                disabled={cuentas.loading}
              >
                <option value="">
                  {cuentas.loading
                    ? "Cargando cuentas..."
                    : "Seleccione una cuenta"}
                </option>

                {cuentas.data.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.codcga} - {c.cuentagasto}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-3">
              <label>Gasto</label>
              <input
                type="text"
                className="form-control"
                name="gasto"
                required
                value={formValues.gasto}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="activo"
                  name="activo"
                  checked={!!formValues.activo}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="activo">
                  Activo
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormGasto;